// Copyright (c) 2026 Aravind Adari. All rights reserved.

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ReceptionistPage from "./pages/ReceptionistPage";
import ManagerPage from "./pages/ManagerPage";
import AdminPage from "./pages/AdminPage";
import LeavePage from "./pages/LeavePage";
import ReportsPage from "./pages/ReportsPage";
import PlatformPage from "./pages/PlatformPage";
import { RequireAuth } from "./components/RequireAuth";
import AppLayout from "./components/AppLayout";
import SettingsPage from "./pages/SettingsPage";
import { ClientProvider } from "./contexts/ClientContext";

function App() {
  return (
    <ClientProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Platform Super Admin — only super_admin platform claim */}
          <Route
            path="/platform"
            element={
              <RequireAuth platformAdmin>
                <AppLayout><PlatformPage /></AppLayout>
              </RequireAuth>
            }
          />

          {/* Client routes */}
          <Route
            path="/timesheet"
            element={
              <RequireAuth allowedRoles={["receptionist", "admin"]}>
                <AppLayout><ReceptionistPage /></AppLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/leave"
            element={
              <RequireAuth allowedRoles={["receptionist", "manager", "admin"]}>
                <AppLayout><LeavePage /></AppLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/payroll"
            element={
              <RequireAuth allowedRoles={["manager", "admin"]}>
                <AppLayout><ManagerPage /></AppLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/admin"
            element={
              <RequireAuth allowedRoles={["admin"]}>
                <AppLayout><AdminPage /></AppLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/reports"
            element={
              <RequireAuth allowedRoles={["manager", "admin"]}>
                <AppLayout><ReportsPage /></AppLayout>
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth allowedRoles={["manager", "admin"]}>
                <AppLayout><SettingsPage /></AppLayout>
              </RequireAuth>
            }
          />

          {/* Legacy redirects */}
          <Route path="/receptionist" element={<Navigate to="/timesheet" replace />} />
          <Route path="/attendance" element={<Navigate to="/timesheet" replace />} />
          <Route path="/manager" element={<Navigate to="/payroll" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ClientProvider>
  );
}

export default App;
